import React from 'react';
import { Typography } from '@inplayer-org/inplayer-ui';

// components
import { ContentContainer, CenterContent, StyledTypography } from 'components/SharedStyledElements';

const DataCaptureNoAuth: React.FC = () => (
  <ContentContainer>
    <CenterContent>
      <StyledTypography variant="p">
        This feature is currently being developed. We want to provide you here with the option to define data fields you
        want your end-users to enter when accessing content of this asset.
      </StyledTypography>
      <Typography variant="p">
        Please contact support at <a href="mailto:support@inplayer.com">support@inplayer.com</a> if you need anything
        specific at the moment.
      </Typography>
    </CenterContent>
  </ContentContainer>
);

export default DataCaptureNoAuth;
